export default "__VITE_ASSET__B$6FR_Br__"